var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40.4 31",
    style: {
      enableBackground: "new 0 0 40.4 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6FBE52;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.4,3.1c0,1.2-0.7,1.8-1.2,2.4c-7.7,8.1-15.5,16.1-23.2,24.3c-1.3,1.3-2.4,1.6-3.7,0.2 c-3.7-4.1-7.5-8.2-11.3-12.2c-1.7-1.8-0.7-3,0.7-4.3c1.5-1.4,2.7-1.4,4.1,0.1c2.1,2.3,4.3,4.4,6.2,6.8c1.6,2,2.7,1.7,4.3,0 c6-6.4,12.1-12.6,18.1-18.9c0.9-0.9,1.8-1.9,3.2-1.2C38.8,0.9,39.7,2,40.4,3.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerList);
export default __webpack_public_path__ + "static/media/marker-list.666eb9ef80496068771e063ca5606291.svg";
export { ForwardRef as ReactComponent };